import { FollowState } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import { useMemo } from "react"
import styles from "./Following.module.scss"
import { SharersList } from "./SharersList"
import { PageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import {
  useAccount,
  useFollows,
} from "src/hooks"

const polyglotPrefix = "pages.data_sharing.following."

const MAX_FOLLOWS = 20

export function Following() {
  const polyglot = usePolyglot()

  const { data: account } = useAccount()
  const accountId = account?.id

  const { data: follows } = useFollows()
  const following = useMemo(
    () => follows?.filter(
      (follow) => follow.is_self !== true &&
          follow.account_id === accountId &&
          (follow.state === FollowState.Provisioned ||
            follow.state === FollowState.Active),
    ),
    [
      follows,
      accountId,
    ],
  )

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.following")}
      backRoutePath="/data_sharing"
    >
      <div className={styles.container}>
        <div className={styles.summaryContainer}>
          {following && following.length >= MAX_FOLLOWS ? (
            <div className={styles.summaryDescription}>
              {polyglot.t(`${polyglotPrefix}description_max_following`)}
            </div>
          ) : following && following.length > 0 ? (
            <div className={styles.summaryDescription}>
              {polyglot.t(`${polyglotPrefix}description_following`)}
            </div>
          ) : (
            <>
              <div className={styles.summaryTitle}>
                {polyglot.t(`${polyglotPrefix}title_not_following`)}
              </div>
              <div className={styles.summaryDescription}>
                {polyglot.t(`${polyglotPrefix}description_not_following`)}
              </div>
            </>
          )}
          <ActionLink asChild>
            <Link
              to="/data_sharing/following/accept_invite"
              disabled={following && following.length >= MAX_FOLLOWS}
              id="accept-invitation-btn"
            >
              {polyglot.t(`${polyglotPrefix}accept_invitation`)}
            </Link>
          </ActionLink>
        </div>
        {following && following.length > 0 ? (
          <SharersList follows={following} />
        ) : null}
      </div>
    </PageTemplate>
  )
}
